import { apiClient } from '@/core/api/client';
import { ExpertiseData, PipelineFilters, APIResponse } from '../types/pipeline.types';

export const pipelineApi = {
  /**
   * Get all expertise data from FileMaker API
   * Endpoint: GET /api/fm/expertises
   * Original: fmAPI.getAllExpertiseData() from shared/utils/api.js:547
   */
  getAllExpertiseData: async (params: PipelineFilters = {}): Promise<APIResponse> => {
    try {
      const queryString = new URLSearchParams(params as any).toString();
      const response = await apiClient.get(`/api/fm/expertises${queryString ? `?${queryString}` : ''}`);
      
      // Handle the response format
      if (response && typeof response === 'object') {
        // If response has a data property, use it
        if ('data' in response) {
          return response as APIResponse;
        }
        // If response is directly the data array
        if (Array.isArray(response)) {
          return {
            success: true,
            data: response as ExpertiseData[]
          };
        }
        // If response has success and data properties
        if ('success' in response && 'data' in response) {
          return response as APIResponse;
        }
      }
      
      // Default response if format is unexpected
      return {
        success: false,
        data: [],
        error: 'Unexpected response format'
      };
    } catch (error) {
      return {
        success: false,
        data: [],
        error: error instanceof Error ? error.message : 'Failed to fetch expertise data'
      };
    }
  },
  
  /**
   * Get expertise data for a specific stage
   * This can be handled client-side by filtering getAllExpertiseData result
   */
  getStageData: async (stageId: number): Promise<ExpertiseData[]> => {
    const response = await pipelineApi.getAllExpertiseData();
    if (response.success && response.data) {
      return response.data.filter(exp => exp.stage === stageId);
    }
    return [];
  }
};